import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, MessageCircle } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { WHATSAPP_AFFILIATE } from "../mock";

export default function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#FBF8F4]" data-testid="privacy-policy-page">
      <Header />
      <main className="container-y px-5 md:px-8 py-16 md:py-24 max-w-3xl">
        <Link
          to="/"
          data-testid="privacy-back-link"
          className="inline-flex items-center gap-2 font-sans-y text-[12px] tracking-[0.2em] uppercase text-[#7a7a7a] hover:text-[#C9A961] transition-colors mb-8"
        >
          <ArrowLeft size={14} /> Back to home
        </Link>

        <p className="font-sans-y text-[11px] tracking-[0.35em] uppercase text-[#C9A961] mb-4">
          Legal
        </p>
        <h1 className="font-serif-y text-4xl md:text-5xl text-[#1a1a1a] mb-4">Privacy Policy</h1>
        <p className="font-sans-y text-[13px] text-[#7a7a7a] mb-10">Last updated: {new Date().getFullYear()}</p>

        <div className="space-y-8 font-sans-y text-[15px] leading-relaxed text-[#444]">
          <section>
            <p>
              USA Fashion Hair ("we", "us") operates this website as an independent authorized
              Ybera Paris affiliate. This page explains, in simple terms, what data we collect and
              how it is used when you visit our site.
            </p>
          </section>

          <section>
            <h2 className="font-serif-y text-2xl text-[#1a1a1a] mb-3">Analytics &amp; advertising</h2>
            <p>
              We use <strong>Google Analytics</strong> and <strong>Google Ads</strong> tags and
              cookies to understand how visitors use the site and to measure the performance of our
              advertising campaigns. These tools may collect information such as your approximate
              location, device and browser type, pages viewed, and the actions you take (for
              example, clicking a product or a WhatsApp button). This information helps us improve
              the site and show more relevant ads. You can opt out of Google Analytics using
              Google's browser add-on, and manage ad personalization in your Google account
              settings.
            </p>
          </section>

          <section>
            <h2 className="font-serif-y text-2xl text-[#1a1a1a] mb-3">Purchases</h2>
            <p>
              We do not sell products directly and we do not process any payments on this website.
              All purchases are completed securely on the official Ybera store at{" "}
              <a
                href="https://ybera.us/?p=8479159"
                target="_blank"
                rel="noreferrer"
                className="text-[#C9A961] underline underline-offset-2"
              >
                ybera.us
              </a>
              . When you click a product or buy button, you are redirected to the official Ybera
              store, where their own privacy policy, terms and payment processing apply. We do not
              collect or store your payment details.
            </p>
          </section>

          <section>
            <h2 className="font-serif-y text-2xl text-[#1a1a1a] mb-3">Cookies</h2>
            <p>
              Cookies are small files stored by your browser. We use them only for the analytics
              and advertising purposes described above. You can disable cookies at any time in your
              browser settings, though some parts of the site may not function as intended.
            </p>
          </section>

          <section>
            <h2 className="font-serif-y text-2xl text-[#1a1a1a] mb-3">Contact</h2>
            <p>
              If you have any questions about this policy, reach out to us on WhatsApp at{" "}
              <strong>+55 (13) 98167-5693</strong>.
            </p>
            <a
              href={WHATSAPP_AFFILIATE}
              target="_blank"
              rel="noreferrer"
              data-testid="privacy-whatsapp-contact"
              className="btn-whatsapp mt-5"
            >
              <MessageCircle size={18} /> Message us on WhatsApp
            </a>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}
